import { render, staticRenderFns } from "./BuildingView.vue?vue&type=template&id=3a715642&scoped=true"
import script from "./BuildingView.vue?vue&type=script&lang=js"
export * from "./BuildingView.vue?vue&type=script&lang=js"
import style0 from "./BuildingView.vue?vue&type=style&index=0&id=3a715642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a715642",
  null
  
)

export default component.exports